module.exports = __webpack_public_path__ + "img/2.c6f0f5a6.png";